import {JsonProperty} from 'json-typescript-mapper';
import { Marketdate } from './';
import { Contact } from './';
import {Electricmeter} from './electricmeter.model';

export enum TimestampType {
  Before = <any>'Before',
  After = <any>'After',
  Meanwhile = <any>'Meanwhile'

}

export enum Origin {
  AppNew = <any>'AppNew',
  BackOfficeNew = <any>'BackOfficeNew',
  BackOfficeUpdate = <any>'BackOfficeUpdate'
}

export class MarketdateMeterreading {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('value')
  public value?: number;

  @JsonProperty('timestampType')
  public timestampType?: TimestampType;

  @JsonProperty('timestamp')
  public timestamp?: any;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty({clazz: Contact, name: 'updatedBy'})
  public updatedBy?: Contact;

  @JsonProperty({clazz: Electricmeter, name: 'electricmeter'})
  public electricmeter?: Electricmeter;

  @JsonProperty('lastReadingId')
  public lastReadingId?: number;

  @JsonProperty('notAccessible')
  public notAccessible?: boolean;

  @JsonProperty('origin')
  public origin?: Origin;

  constructor() {
    this.id = void 0;
    this.value = void 0;
    this.timestampType = void 0;
    this.timestamp = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.marketdate = void 0;
    this.updatedBy = void 0;
    this.electricmeter = void 0;
    this.lastReadingId = void 0;
    this.notAccessible = void 0;
    this.origin = void 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/marketdate-meterreading.model.ts